import { LocaleObject } from "yup";

/**
 * `validationsLocale` provides custom Portuguese (Portugal) validation messages
 * for use with Yup schemas across the application.
 *
 * These messages override Yup's default error strings and allow for localization
 * and consistency throughout all validation feedback.
 */
export const validationsLocale: LocaleObject = {
  mixed: {
    /**
     * Fallback message when no specific validation error matches.
     */
    default: "Valor inválido",

    /**
     * Used when a required field is left empty.
     */
    required: "Este campo é obrigatório",

    /**
     * Used when the value is not one of the allowed options.
     */
    oneOf: ({ values }) =>
      `Deve ser um dos seguintes valores: ${values.join(", ")}`,

    /**
     * Used when the value should not be one of the provided options.
     */
    notOneOf: ({ values }) =>
      `Não pode ser um dos seguintes valores: ${values.join(", ")}`,
  },

  string: {
    length: ({ length }) => `Deve ter exatamente ${length} caracteres.`,
    min: ({ min }) => `Deve ter pelo menos ${min} caracteres.`,
    max: ({ max }) => `Deve ter no máximo ${max} caracteres.`,
    email: "O formato do e-mail é inválido.",
    url: "O formato do URL é inválido.",
    trim: "Não deve conter espaços no início ou no fim.",
    lowercase: "Deve estar em letras minúsculas.",
    uppercase: "Deve estar em letras maiúsculas.",
  },

  number: {
    min: ({ min }) => `Deve ser no mínimo ${min}.`,
    max: ({ max }) => `Deve ser no máximo ${max}.`,
    lessThan: ({ less }) => `Deve ser menor que ${less}.`,
    moreThan: ({ more }) => `Deve ser maior que ${more}.`,
    positive: "Deve ser um número positivo.",
    negative: "Deve ser um número negativo.",
    integer: "Deve ser um número inteiro.",
  },

  date: {
    min: ({ min }) => `Deve ser posterior a ${min}.`,
    max: ({ max }) => `Deve ser anterior a ${max}.`,
  },

  array: {
    min: ({ min }) => `Deve ter no mínimo ${min} itens.`,
    max: ({ max }) => `Deve ter no máximo ${max} itens.`,
  },
};
